module.exports = __webpack_public_path__ + "images/guangdong_banner01.jpg?85dd14d3eaaada94ec557e14fdd63ab7";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/guangdong_banner01.jpg
// module id = 180
// module chunks = 1